import * as React from 'react';
import { StatusActionsProps } from "./status-actions.types";
import { FolderPrimaryListDto } from '@common/dto/folder/primary-list-dto';
import { HttpErrorDto } from '@common/dto/http';
import { I18n } from 'react-redux-i18n';
import { EmailTemplateListDto } from '@common/dto/email-template/list';
import { FieldType } from '@common/dto/field/type';

export const useStatusActionsController = (props: StatusActionsProps) => {
  const { getBaseFolders, getEmailTemplates, showErrorMessage, getFolders, getFields } = props;

  const [folders, setFolders] = React.useState<Array<FolderPrimaryListDto>>([]);
  const [emailTemplates, setEmailTemplates] = React.useState<Array<EmailTemplateListDto>>([]);

  React.useEffect(() => {
    getBaseFolders()
      .then((x) => {
        setFolders(x);
      })
      .catch((err) => {
        console.error(err);
        showErrorMessage((err as HttpErrorDto | undefined)?.entity ?? I18n.t('Failed to get folders'))
      });

    getEmailTemplates()
      .then(setEmailTemplates)
      .catch((err) => {
        console.error(err);
        showErrorMessage(err?.entity || I18n.t("Failed to get email templates"));
      });
  }, []);

  const getFoldersForAfterThisDateField = React.useCallback(() => {
    return getFolders().then((folders) => {
      return folders.filter((x) => !x.system);
    })
  }, [getFolders]);

  const getFieldsForAfterThisDateField: typeof getFields = React.useCallback((...args) => {
    const allowedFieldTypes = [FieldType.date, FieldType.tableSummary, FieldType.computed];
    
    return getFields(...args).then((fields) => {
      return fields.filter((x) => allowedFieldTypes.includes(x.fieldTypeId));
    })
  }, [getFolders]);

  return {
    getFieldsForAfterThisDateField,
    getFoldersForAfterThisDateField,
    folders,
    emailTemplates,
  };
};